<main class="dashboard-list-page">
  <header class="page-heading">
    <p class="eyebrow">KPI Dashboards</p>
    <h1>個人支援ボード</h1>
    <p>表示するボードを選択してください。</p>
  </header>

  @if (isLoading) {
    <div class="status" aria-live="polite">
      <mat-spinner diameter="32"></mat-spinner>
      <span>ボードを読み込んでいます...</span>
    </div>
  } @else if (loadFailed) {
    <section class="status">
      <mat-icon aria-hidden="true">error_outline</mat-icon>
      <p>ボードの読み込みに失敗しました。</p>
    </section>
  } @else if (dashboards.length > 1) {
    <section class="dashboard-grid" aria-label="個人支援ボード一覧">
      @for (dashboard of dashboards; track dashboard.id) {
        <mat-card appearance="outlined">
          <mat-card-header>
            <mat-icon mat-card-avatar aria-hidden="true">dashboard</mat-icon>
            <mat-card-title>
              <a [routerLink]="['/kpi-dashboards', dashboard.id]">
                {{ dashboard.name }}
              </a>
            </mat-card-title>
          </mat-card-header>
        </mat-card>
      }
    </section>
  } @else {
    <!-- 0 件はガードが /home へ倒すためここには到達しない（1 件時の自動遷移中表示） -->
    <div class="status" aria-live="polite">
      <mat-spinner diameter="32"></mat-spinner>
      <span>ボードへ移動しています...</span>
    </div>
  }
</main>
